<script>
import { onMount } from "svelte";
import * as m from "@app/paraglide/messages.js";
import {
    themeState,
    setAppTheme,
    initAppTheme,
    handleSystemThemeChange,
} from "@app/store/themeStore.svelte.js";
import Menu from "../menu/Menu.svelte";
import MenuItem from "../menu/MenuItem.svelte";

let themeIcon = $derived(
    themeState.mode === "dark"
        ? "bi-moon-stars-fill"
        : themeState.mode === "auto"
          ? "bi-circle-half"
          : "bi-sun-fill",
);

onMount(() => {
    initAppTheme();
    window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", handleSystemThemeChange);
});
</script>

<Menu
    id="theme"
    icon={themeIcon}
    ariaLabel={m.theme_selection()}
    alignEnd>
    <MenuItem
        label={m.light()}
        icon="bi-sun-fill"
        id="lightThemeBtn"
        checked={themeState.mode === "light"}
        onSelect={() => setAppTheme("light")} />
    <MenuItem
        label={m.dark()}
        icon="bi-moon-stars-fill"
        id="darkThemeBtn"
        checked={themeState.mode === "dark"}
        onSelect={() => setAppTheme("dark")} />
    <MenuItem
        label={m.auto_theme()}
        icon="bi-circle-half"
        id="autoThemeBtn"
        checked={themeState.mode === "auto"}
        onSelect={() => setAppTheme("auto")} />
</Menu>
